import { isFunction } from 'lodash'
import { isEmptyArray } from './utils/tools'
import { COMMON_PROPS } from './props/common'
import { SINGLE_PROPS } from './props/single'
import './style/single.scss'

export default {
  props: {
    ...COMMON_PROPS,
    ...SINGLE_PROPS
  },
  data() {
    return {
      isFocus: false
    }
  },
  render(h) {
    const props = this.$props
    // 作用域插槽
    const renderSlotProps = slotProps => {
      const label = this.$props.labelKeys
        .reduce((str, key) => {
          str += slotProps.item[key] + '，'
          return str
        }, '')
        .slice(0, -1)
      return (
        <div
          class={{
            'kye-employee-search__option': slotProps && slotProps.item && slotProps.item.optionDisabled,
            'kye-employee-search-item': true
          }}>
          {label}
        </div>
      )
    }

    const renderOptionSlot = this.$scopedSlots && this.$scopedSlots.default ? this.$scopedSlots.default : renderSlotProps

    const autocompleteAttrs = {
      attrs: {
        readonly: props.readonly
      },
      props: {
        ...(props.autocompleteAttrs || {}),
        value: props.value,
        fetchSuggestions: this.handleFetchSuggestionsEvent,
        'popperClass': (props.autocompleteAttrs.popperClass || '') + ' kye-employee-search',
        placeholder: props.placeholder,
        triggerOnFocus: false, // 是否在输入框 focus 时显示建议列表
        disabled: props.disabled
        // select-when-unmatched 在输入没有任何匹配建议的情况下，按下回车是否触发 select 事件
      },
      class: 'kye-employee-search-autocomplete-input',
      style: {
        width: '100%'
      },
      on: {
        input: this.handleInput,
        focus: this.handleFocus,
        blur: this.handleBlur,
        select: this.handleSelect
      },
      nativeOn: {
        mouseenter: () => this.changeFocus(true),
        mouseleave: () => this.changeFocus(false)
      },
      ref: 'searchTips',
      scopedSlots: {
        default: slotProps => renderOptionSlot(slotProps)
      }
    }

    // 清除按钮
    const renderClear = () => {
      const showClear = this.value && this.clearable && !props.disabled && this.isFocus
      return showClear ? (
        <i
          slot="suffix"
          class="el-input__icon el-icon-circle-close search-tips-clear"
          on-click={this.handleClearEvent}></i>
      ) : null
    }
    const clear = renderClear()
    const renderAutoComplete = () => {
      return <el-autocomplete {...autocompleteAttrs}>{clear}</el-autocomplete>
    }
    const autoCompleteNode = renderAutoComplete()
    return autoCompleteNode
  },
  methods: {
    changeFocus(val) {
      this.isFocus = val
    },
    handleInput(val) {
      this.$emit('inputChange', val)
      if (val) {
        val = val.trim()
      }
      if (val === '') {
        this.$emit('clear')
        this.setOptions([])
      }
    },
    handleFocus() {
      this.changeFocus(true)
      this.$emit('focus')
    },
    handleBlur(e) {
      this.changeFocus(false)
      this.setLoading(false)

      setTimeout(() => {
        if (this.$props.clearOptionsAfterBlur) {
          if (this.$props.value !== this.$refs.searchTips.$refs.input.currentValue) {
            this.$refs.searchTips.$refs.input.currentValue = this.value
            this.setOptions([])
          }
        }
        this.$emit('blur', this.value, e)
      }, 300)
    },
    handleSelect(val) {
      this.$emit('select', val)
    },
    // 自动选择第一行
    setHighlight(data) {
      this.$nextTick(_ => {
        let searchTipsRef = this.$refs.searchTips
        if (!searchTipsRef || !data.length) return
        searchTipsRef.highlight && searchTipsRef.highlight(0)
      })
    },
    handleFetchSuggestionsEvent(val, cb) {
      if (isFunction(this.$props.fetchSuggestions)) {
        const fn = data => {
          const emptyArray = isEmptyArray(data)
          this.setLoading(false)
          if (!data || emptyArray) {
            if (emptyArray) {
              this.setOptions([])
            }
            if (this.$props.clearSelectByEmptySearch) {
              this.$emit('select', null)
            }
          } else {
            cb(data)
            this.setHighlight(data)
          }
        }
        const result = this.$props.fetchSuggestions(val)
        if (result && result.then) {
          result.then(data => {
            fn(data)
          })
        } else {
          fn(result)
        }
      }
    },
    setLoading(val) {
      this.$refs.searchTips.loading = val
    },
    setOptions(val = []) {
      this.$refs.searchTips.suggestions = val
    },
    handleClearEvent(event) {
      event.preventDefault()
      this.$emit('clear')
      this.setOptions([])
      this.$emit('input', '')
      this.$emit('select', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/single.js